export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_q03_a.3aaf683a.png";